import React from 'react'
import { useNavigation } from '@react-navigation/native'
import { View } from 'react-native'
import { useTheme } from '@ui-kitten/components'
import { StyleService, useStyleSheet } from '@src/style/service'
import { useIsDarkMode } from '@src/config/theme'
import { WarningBanner } from '@src/screens/Home/components/Banners/WarningBanner'
import { useAcknowledgeLabResultAnalysisFailed } from '@src/screens/LabResults/hooks'
import { Icon, Text } from '../base'
import { useShowLabResultAnalysisCompletePopup } from './hooks/useShowLabResultAnalysisCompletePopup'

export const LabResultAnalysisCompletePopup = () => {
  const { analysisSuccess, analysisFailed } = useShowLabResultAnalysisCompletePopup()
  const navigation = useNavigation()
  const styles = useStyleSheet(themedStyles)
  const theme = useTheme()
  const isDarkMode = useIsDarkMode()
  const acknowledgeLabResultFailed = useAcknowledgeLabResultAnalysisFailed()

  if (!analysisSuccess && !analysisFailed) {
    return null
  }

  const successHeadlineText = 'Lab results are ready to view'
  const failureHeadlineText = 'Lab result analysis failed'
  const successBodyText = 'Tap to view now.'
  const failureBodyText = 'Please try uploading your lab result again.'
  const bodyTextColor = isDarkMode ? theme['theme.text.secondary'] : theme['theme.text.primary']
  const backgroundColor = isDarkMode
    ? theme['theme.background']
    : theme['theme.marketing.lightYellow']
  const darkModeBorder = { borderColor: theme['theme.warning.lighter'], borderWidth: 1 }

  const onBannerPress = () => {
    if (analysisSuccess) {
      return navigation.navigate('LabResultsScreen')
    }

    acknowledgeLabResultFailed()
    navigation.navigate('UploadLabResults', { file: undefined })
  }

  const icon = (
    <View style={styles.iconContainer}>
      <Icon name="flask" style={styles.icon} />
    </View>
  )

  const headlineText = analysisSuccess ? successHeadlineText : failureHeadlineText
  const bodyText = analysisSuccess ? successBodyText : failureBodyText

  const body = (
    <View style={styles.textContainer}>
      <Text type="regular" style={[{ color: bodyTextColor }]}>
        <Text type="regular" bold style={styles.headlineText}>
          {headlineText}
        </Text>{' '}
        {'\n'}
        {bodyText}
      </Text>
    </View>
  )

  return (
    <WarningBanner
      accessibilityLabel="View New Lab Results"
      onPress={onBannerPress}
      image={icon}
      body={body}
      containerStyle={[{ backgroundColor }, isDarkMode ? darkModeBorder : {}]}
    />
  )
}

const themedStyles = StyleService.create({
  icon: {
    width: 24,
    height: 24,
    color: 'theme.marketing.subtleText',
  },
  iconContainer: {
    backgroundColor: 'theme.marketing.yellow',
    borderRadius: 24,
    width: 48,
    height: 48,
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 16,
  },
  textContainer: {
    flex: 1,
    marginRight: 8,
  },
  headlineText: {
    color: 'theme.text.primary',
  },
})
